/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Badge_OverdueInputs */



/**
* | output |
* | --- |
* | "Approval overdue" |
*
* @param {Partner_Org_Contract_Badge_OverdueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_badge_overdue = /** @type {((inputs?: Partner_Org_Contract_Badge_OverdueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Badge_OverdueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Freigabe überfällig")
	return /** @type {LocalizedString} */ ("Approval overdue")
});